import React, { useState } from "react";

interface PDPAdminDetailProps {
  id: string;
  published: boolean;
}

const PDPAdminDetail: React.FC<PDPAdminDetailProps> = ({ id, published }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* Open Menu Button */}
      {!isOpen && (
        <button
          data-test-id="pdp-admin-button"
          onClick={() => setIsOpen(true)}
          className="bg-wine100 border-wine300 text-wine px-4 py-2 rounded fixed bottom-4 right-4 z-50">
          Admin
        </button>
      )}

      {/* Flyout Menu */}
      {isOpen && (
        <div data-test-id="pdp-admin-flyout" className="p-2 mt-2 w-48 bg-white border border-wine300 rounded shadow-lg">
          <div className="flex flex-col gap-2">
            <p className="font-semibold flex justify-between">
              {id}
              <button onClick={() => setIsOpen(false)} className="text-sm pr-2">
                ✕
              </button>
            </p>
            <p>{published ? "Published" : "Unpublished"}</p>
            <p>
              <a className="underline" href={`/pdp/admin_redirect/${id}`} rel="noopener noreferrer" target="_blank">
                Edit Item
              </a>
            </p>
            <p>
              <a href={`/pdp/admin_availability/${id}`} className="underline" rel="noopener noreferrer" target="_blank">
                Show availability
              </a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PDPAdminDetail;
